import useAppMutation from 'hooks/useAppMutation';
import API from 'services/API';

const useCompleteOnboarding = () => {
  return useAppMutation(({ token }: { token: string }) => {
    return API.post<{ externalRedirectUrl?: string; userAccessToken?: string }>(
      '/api/identity/internal/onboarding/complete',
      { token },
    );
  });
};

export default useCompleteOnboarding;
